import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import HighlightsQuiz from "./HighlightsQuiz";
import FAQsQuiz from "./FAQsQuiz";
import RichTextCardPopUp from "./RichTextCardPopUp";
import ImageWithFallback from "../../../UI/ImageFallBack";
import UploaderAllCM from "../Uploader/UploaderAllCM";
import { getAllFilesBys3Key } from "../../../../store/actions/CreateContent/FolderAPI/LessonAPI";
import { re } from "mathjs";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const QuizThumbnail= ({quizObjectID,setQuizObjectDataBack})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
      const [goNextPopUp, setGoNextPopUp] =useState(false);
     
     const [activeStep, setActiveStep] = useState(0);
     const [activeSubStepOne, setActiveSubStepOne] = useState(3);
     
     const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
     const [activeSubStepThree, setActiveSubStepThree] = useState(0);
     const [activeSubStepFour, setActiveSubStepFour] = useState(0);
     const [activeSubStepFive, setActiveSubStepFive] = useState(0);
     const [titleActive, setTitleActive] = useState(true);
     const [desctiptionActive, setDesctiptionActive] = useState(false);
     const [highlightActive, setHighlightActive] = useState(false);
     const [FAQActive, setFAQActive] = useState(false);
      const [openUploaderPopUp, setOpenUploaderPopUp] = useState(false);
         const [currentFileType, setCurrentFileType] = useState({});
       const [currentFileObject,setCurrentFileObject] = useState({}); 
          const [currentFile,setCurrentFile] = useState(""); 
           
        const [thumbnail, setThumbnail] = useState("");
             
             
    const steps = ([{number:1,name:"Quiz Thumbnail"}]);
    const subSteps = [1, 2, 3, 4, 5];
    const subStepOneTotal= 3;
    const subStepTwoTotal= 3;
    const subStepThreeTotal= 3;
    const subStepFourTotal= 3;
    const subStepFiveTotal= 3;
    ;
          const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [quizDescription,  setQuizDescription] = useState("");
        const [higlights,  setHiglights] = useState([]);
        const [FAQs,  setFAQs] = useState([]);
        
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({});
   
    const userdata = useSelector((state)=>state?.user?.user);



      const fireFetchFileLinkByS3Key=(thumbnailKey)=>{
          
                      
          setLoader({status:true});
            const apiData = dispatch(getAllFilesBys3Key({userEmail:user_email?user_email:null,
            currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,fileKey:thumbnailKey,
            editType:"getFileListByS3Key"}));
            /* get response as Promise   */
            apiData.then(response => {
              if(response){
        
                
                if(response){
                setCurrentFile(response?.file?.file)
                setCurrentFileObject(response?.file)
               
      
             }else{
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
             }
                
             
             if(response?.logout){
             
              setResponseMessage("You are Logged Out!!!");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              setTimeout(()=>{
                dispatch({type:"LOGOUT"});
          
              },3000)
              
            }
          /* resetting Login input Fields */
          
              }else{
                setResponseMessage("Something Went Wrong...");
                
                setSnackbarColor("#958FDA");
             
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)    }
          
            }).catch(error => {
           
              //popup of error Info
              setResponseMessage("Something Went Wrong...");
                
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)
              console.error(error);
            });
           
            }
   useEffect(()=>{
   
   fireGetQuizDataByQuizId()
   
   },[])
   useEffect(()=>{
   
    setAnimate(false);  
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 1000);
 
    return () => clearTimeout(timer); 
    },[titleActive,desctiptionActive,highlightActive,FAQActive])
   const fireGetQuizDataByQuizId=()=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({thumbnail:thumbnail,type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
         
          //  thumbnail,PDFlink
          if(response?.quiz){
              setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
     
          setQuizObject(response?.quiz)
      setThumbnail(response?.quiz?.thumbnail) ;
      setQuizDescription(response?.quiz?.descripton)
      setHiglights( response?.quiz?.higlights?JSON.parse(response?.quiz?.higlights):[])
      setFAQs( response?.quiz?.FAQs?JSON.parse(response?.quiz?.FAQs):[])
      setLoader({status:false});
    
   fireFetchFileLinkByS3Key(response?.quiz?.thumbnail);
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
     const handleCreateNewMockTest=(editType,val)=>{
     let SendObject=""
     if(editType=="thumbnail"){
        SendObject={thumbnail:val,type:"mock",
            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
           
                     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest(SendObject));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
           if(response?.quiz){
            
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
       setQuizObject(response?.quiz)
       
       
       setQuizObjectDataBack(response?.quiz)
     setLoader({status:false});
      setThumbnail(response?.quiz?.thumbnail);
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
       
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
       
   
       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
       
      <div  className=""style={{marginTop:"40px"}}><div  className=" " style={{background:"#fff",borderRadius:"25px",paddingBottom:"50px"}}>

 {titleActive?
    <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Add Quiz  <span className="coloredTextV1" > Thumbnail </span></h2>
   
<div className="" style={{display:"flex",justifyContent:"space-around",background:"rgba(144, 202, 249,0.2)",borderRadius:"10px",marginTop:"10px",marginLeft:"10px",marginRight:"10px",marginBottom:"10px",paddingLeft:"10px",paddingTop:"5px",paddingBottom:"5px",paddingBottom:"5px"}}> 
        <div style={{"textAlign":"center",
     top: animate ? '0px' : '20px',position:"relative",
     opacity: animate ? 1 : 0.5,
     transition: 'top 1s ease, opacity 1s ease',
   marginTop:"0px"}}>{
            currentFile?<ImageWithFallback src={currentFile} widthOuter={"170px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>:
            <ImageWithFallback src={""} widthOuter={"170px"} fireOpenEdit ={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}  iconSize={28} setOpenFullImg={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}/>}
   </div> 
   
   
   
    <div style={{"textAlign":"center",
     top: animate ? '0px' : '-20px',position:"relative",
     opacity: animate ? 1 : 0.5,
     transition: 'top 1s ease, opacity 1s ease',
   marginTop:"0px",display:"flex",justifyContent:"center",alignItems:"center",}} >
    <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setOpenUploaderPopUp(true);;setCurrentFileType({ title: "Image", value: "image" })}}   className=" CoursesPreviewTopBtn"  type="submit"
   > Upload Image </button>
   </div>
   </div>

 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
    <div  >   </div>
  
    
</div> </div>:""}
 {openUploaderPopUp && (
           <UploaderAllCM
             fileTypeObject={[currentFileType]}
            selectedFileObject={currentFileObject} currentFileObject={currentFileObject} setCurrentFileObject={(v)=>{setCurrentFileObject(v);
                handleCreateNewMockTest("thumbnail",v?.file_s3_key);setThumbnail(v?.file_s3_key);
                // handleCreateNewRichContent(currentFileType?.value,currentFileObject)
            }}
             setCloseUploaderPopUp={() => setOpenUploaderPopUp(false)}
           />
         )} 
    
 <div>
     </div>
    
    </div>
    </div>
     </>


}
export default QuizThumbnail;